import { Visibility } from './Visibility'

export class MultiplayerSession {
    multiplayerSessionId?: string
    creationDate?: Date
    visibility!: Visibility
    isRecordingReplay!: boolean
    currentPlayers!: number
    serverEndpoint?: string
    creatorUserId?: string
    roomMetadataId?: string
    contentVersion?: string
    title?: string
    replayId?: string
    mapName?: string
    companyContentId?: number
    companyContentGuid?: string
    companyContentTag?: string
    companyContentBuildVersion?: string
    creatorUserName?: string
    activeReplayName?: string
    maxPlayers?: number
    region?: string
}
